import { create } from 'zustand';
import { BrokerNewReferralInterface } from '../interfaces/BrokerNewReferralInterface';

const initialReferral: BrokerNewReferralInterface = {
    brokerId: undefined,
    repFirstName: undefined,
    repMiddleName: undefined,
    repLastName: undefined,
    repSuffix: undefined,
    repEmail: undefined,
    businessEntityName: undefined,
    stateIncorporated: undefined,
    iccaAgreement: false,
    clientIsFlagged: false,
    fontId: undefined,
    subjectPropertyInAnyStates: undefined,
    stateNMLSNumber: undefined,
    brokerArizonaLicenseNumber: undefined,
};

interface BrokerNewReferralStore {
    referral: BrokerNewReferralInterface;
    validationEnabled: boolean;

    set_brokerId: (v: number) => void;
    set_repFirstName: (v: string) => void;
    set_repMiddleName: (v: string) => void;
    set_repLastName: (v: string) => void;
    set_repSuffix: (v: string) => void;
    set_repEmail: (v: string) => void;
    set_businessEntityName: (v: string) => void;
    set_stateIncorporated: (v: string) => void;
    set_iccaAgreement: (v: boolean) => void;
    set_clientIsFlagged: (v: boolean) => void;
    set_fontId: (v: number) => void;
    set_subjectPropertyInAnyStates: (v: boolean) => void;
    set_stateNMLSNumber: (v: string | undefined) => void;
    set_brokerArizonaLicenseNumber: (v: string | undefined) => void;

    reset: () => void;
}

export const useBrokerNewReferralStore = create<BrokerNewReferralStore>((set) => ({
    referral: initialReferral,
    validationEnabled: true,

    set_brokerId: (v) => set((s) => ({ referral: { ...s.referral, brokerId: v } })),
    set_repFirstName: (v) => set((s) => ({ referral: { ...s.referral, repFirstName: v } })),
    set_repMiddleName: (v) => set((s) => ({ referral: { ...s.referral, repMiddleName: v } })),
    set_repLastName: (v) => set((s) => ({ referral: { ...s.referral, repLastName: v } })),
    set_repSuffix: (v) => set((s) => ({ referral: { ...s.referral, repSuffix: v } })),
    set_repEmail: (v) => set((s) => ({ referral: { ...s.referral, repEmail: v } })),
    set_businessEntityName: (v) => set((s) => ({ referral: { ...s.referral, businessEntityName: v } })),
    set_stateIncorporated: (v) => set((s) => ({ referral: { ...s.referral, stateIncorporated: v } })),
    set_iccaAgreement: (v) => set((s) => ({ referral: { ...s.referral, iccaAgreement: v } })),
    set_clientIsFlagged: (v) => set((s) => ({ referral: { ...s.referral, clientIsFlagged: v } })),
    set_fontId: (v) => set((s) => ({ referral: { ...s.referral, fontId: v } })),
    set_subjectPropertyInAnyStates: (v) => set((s) => ({ referral: { ...s.referral, subjectPropertyInAnyStates: v } })),
    set_stateNMLSNumber: (v) => set((s) => ({ referral: { ...s.referral, stateNMLSNumber: v } })),
    set_brokerArizonaLicenseNumber: (v) => set((s) => ({ referral: { ...s.referral, brokerArizonaLicenseNumber: v } })),

    reset: () => {
        set({
            referral: initialReferral,
            validationEnabled: false,
        });

        setTimeout(() => set({ validationEnabled: true }), 0);
    },
}));
